import { Skeleton, Stack } from '@mantine/core'

export const ArticleDetailsSkeleton = () => (
  <Stack gap="lg">
    <Skeleton h={24} w="30%" radius="xl" />
    <Skeleton h={48} w="80%" radius="sm" />
    <Skeleton h={16} w="50%" radius="sm" />
    <Skeleton h={200} radius="sm" />
  </Stack>
)
